import { render, staticRenderFns } from "./expariedToken.vue?vue&type=template&id=e84099d6&scoped=true&"
import script from "./expariedToken.vue?vue&type=script&lang=js&"
export * from "./expariedToken.vue?vue&type=script&lang=js&"
import style0 from "./expariedToken.vue?vue&type=style&index=0&id=e84099d6&scoped=true&lang=css&"
import style1 from "./expariedToken.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84099d6",
  null
  
)

export default component.exports